module.exports = __webpack_public_path__ + "static/media/wind-turbines-1.92000fde.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/wind-turbines-1.jpeg
// module id = 1836
// module chunks = 0